import { render, staticRenderFns } from "./BackPaginateComponent.vue?vue&type=template&id=77a2979f"
import script from "./BackPaginateComponent.vue?vue&type=script&lang=js"
export * from "./BackPaginateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports